import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-duotone-solid-svg-icons';
import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  faBed,
  faHotel,
  faLocationArrow,
  faStar,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { dateFormat } from 'utils/utils';
import { useSearchParams } from 'react-router-dom';
import Rating from 'components/ui/Rating/Rating';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { MainContext } from 'contexts/MainContext';
import { defaultLoaderUrl } from 'constants/generic';

const ResultLoadingModal: FC = () => {
  const [t] = useTranslation();
  const [urlParams] = useSearchParams();
  const [guests, setGuests] = useState(0);
  const [rooms, setRooms] = useState(0);
  const {
    cdnUrl,
    isEnigma,
    initSiteData
  } = useContext(MainContext);

  useEffect(() => {
    const roomsStr = urlParams.get('roomsString');
    const roomParts = (roomsStr || '')
      .split(';')
      .map((room) => room.trim())
      .filter(Boolean);
    const newGuests = roomParts.reduce((acc, room: string) => {
      const [adultsRaw, ...ages] = room.split('_');
      const adults = Number.parseInt(adultsRaw, 10);
      return acc + (Number.isFinite(adults) && adults > 0 ? adults : 2) + ages.length;
    }, 0);
    const newRooms = roomParts.length || 1;

    setGuests(newGuests || 2);
    setRooms(newRooms);
  }, [urlParams]); // eslint-disable-line

  return (
    <div className="modal-overlay" style={{ pointerEvents: 'none' }}>
      <div className="modal active modal-hotels default-shadow">
        <div className="title text-center mt-10 mb-20">{t('hotel.search')}</div>

        <div className="flex-center flex-column ">
          <img
            className="mb-20"
            alt="logo"
            src={(cdnUrl || '') + (isEnigma ? initSiteData?.other?.logoUrl || '' : initSiteData?.other?.mainLoaderUrl || initSiteData?.other?.defaultLoaderUrl || defaultLoaderUrl || '')}
          />
          <FontAwesomeIcon icon={faSpinnerThird as any} spinPulse />
        </div>
        <div className="mt-10">
          <div className="bb-1 pb-10 flex">
            <div className="w200px">
              <FontAwesomeIcon icon={faHotel} className="mr-5" />
              {t('search.destination')}
            </div>
            <div className="flex-one flex">{urlParams.get('city')}</div>
          </div>
          <div className="bb-1 pb-10 flex mt-10">
            <div className="w200px">
              <FontAwesomeIcon icon={faLocationArrow} className="mr-5" />
              {t('search.check_in')}
            </div>
            <div className="flex-one flex">
              {dateFormat(urlParams.get('checkIn')!, 'EEE - dd MMM, yyyy')}
            </div>
          </div>
          <div className="bb-1 pb-10 flex mt-10">
            <div className="w200px">
              <FontAwesomeIcon icon={faLocationArrow} className="mr-5" />
              {t('search.check_out')}
            </div>
            <div className="flex-one flex">
              {dateFormat(urlParams.get('checkOut')!, 'EEE - dd MMM, yyyy')}
            </div>
          </div>
          <div className="bb-1 pb-10 flex mt-10">
            <div className="w200px">
              <FontAwesomeIcon icon={faBed} className="mr-5" />
              {t('hotel.rooms')}
            </div>
            <div className="flex-one flex">{rooms}</div>
          </div>
          <div className="bb-1 pb-10 flex mt-10">
            <div className="w200px">
              <FontAwesomeIcon icon={faUsers as any} className="mr-5" />
              {t('passenger.guests')}
            </div>
            <div className="flex-one flex">{guests}</div>
          </div>
          <div className="bb-1 pb-10 flex mt-10">
            <div className="w200px">
              <FontAwesomeIcon icon={faStar} className="mr-5" />
              {t('search.star_rating')}
            </div>
            <div className="flex-one flex">
              <Rating value={urlParams.get('starRating') || 0} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(ResultLoadingModal, 'ResultLoadingModal');
